// Les 16 expériences T'POZ, organisées par besoin.

export const BESOINS = [
  { key: "souffler", label: "Souffler, me reposer, même quelques heures" },
  { key: "prendre-soin", label: "Prendre soin de moi en douceur" },
  { key: "activite", label: "Faire une activité qui me plaît" },
  { key: "partager", label: "Partager un moment avec d'autres femmes" },
];

export const DUREES = [
  { key: "heures", label: "Quelques heures" },
  { key: "demi-journee", label: "Une demi-journée" },
  { key: "journee", label: "Une journée" },
  { key: "nuit", label: "Une nuit ou plus" },
];

export const LIEUX_FILTRE = [
  { key: "grande-terre", label: "Grande-Terre" },
  { key: "basse-terre", label: "Basse-Terre" },
  { key: "domicile", label: "Chez moi" },
];

export const EXPERIENCES = [
  // ——— Souffler, me reposer, même quelques heures ———
  {
    id: "une-heure-de-massage",
    nom: "Une heure de massage",
    rubriques: ["souffler"],
    accroche: "Un temps pour relâcher les tensions, apaiser le corps et reprendre souffle.",
    comprend:
      "Une heure de massage bien-être, dans un cadre calme et bienveillant. Selon la praticienne choisie, il peut s'agir d'un massage californien, d'un massage intuitif, d'un massage relaxant ou d'une réflexologie.",
    dureeLabel: "1 heure",
    dureeCat: "heures",
    lieuxLabel: "Petit-Bourg · Sainte-Anne · à domicile",
    secteurs: ["basse-terre", "grande-terre", "domicile"],
    avantage: "Tarif réduit",
    photo: "/partenaires/massage-tpoz.jpg",
    partenaires: ["L'Art du Calme", "Fée pour Soi", "Détente et Vous By'Ness"],
    offres: [
      {
        type: "Massage californien",
        partenaire: "L'Art du Calme",
        tel: "+590 690 13 11 26",
        secteurs: ["basse-terre", "domicile"],
        lieu: "Petit-Bourg ou à domicile",
        offre:
          "Un massage enveloppant et relaxant pour relâcher les tensions, apaiser le mental et se reconnecter à soi. Linge, table de massage et matériel fournis.",
        duree: "1 heure",
        tarif_public: "90 €/pers.",
        tarif_tpoz: "60 €/pers.",
        avantage: "Tarif réduit",
        photoP: "/partenaires/art-du-calme-cabinet.jpg",
        dispo: "Toute l'année, selon disponibilités",
        resa: "Réservation directe auprès du partenaire, en donnant votre code T'POZ",
        delai_reservation: "Selon disponibilités du partenaire",
      },
      {
        type: "Massage ou réflexologie",
        partenaire: "Fée pour Soi",
        tel: "+590 690 36 16 34",
        secteurs: ["grande-terre"],
        lieu: "Sainte-Anne",
        offre:
          "Une heure de reconnexion à soi, avec un massage ou une séance de réflexologie selon l'offre choisie. Prévoir une serviette pour la séance de massage.",
        duree: "1 heure",
        tarif_public: "65 €/pers.",
        tarif_tpoz: "42 €/pers.",
        avantage: "−35 %",
        photoP: "/partenaires/fee-pour-soi-salon.jpg",
        dispo: "Mercredi à Sainte-Anne, vendredi à Jarry",
        resa: "Réservation directe auprès du partenaire, en donnant votre code T'POZ",
        delai_reservation: "Au moins 5 jours avant",
      },
      {
        type: "Massage relaxant",
        partenaire: "Détente et Vous By'Ness",
        tel: "0690 90 69 18",
        secteurs: ["basse-terre", "domicile"],
        lieu: "Petit-Bourg ou à domicile",
        offre:
          "Un massage profond et relaxant pour favoriser la détente, soulager les tensions et contribuer au bien-être physique et mental.",
        duree: "1 heure",
        tarif_public: "80 €/pers.",
        tarif_tpoz: "50 €/pers.",
        avantage: "Tarif réduit",
        photoP: "/partenaires/byness-plage.jpg",
        dispo: "Mardi au samedi, 9 h à 18 h, hors congés",
        resa: "Réservation obligatoire auprès du partenaire, en donnant votre code T'POZ",
        delai_reservation: "Selon disponibilités du partenaire",
      },
    ],
  },
  {
    id: "une-journee-spa",
    nom: "Une journée spa, de 10 h à 22 h",
    rubriques: ["souffler"],
    accroche: "Une journée entière pour soi, entre spa privatif, collation et massage.",
    comprend:
      "Une journée complète de bien-être, de 10 h à 22 h, dans un gîte paisible à deux pas des plages : accès au lieu et au spa privatif, collation, massage et temps d'échange.",
    dureeLabel: "1 journée",
    dureeCat: "journee",
    lieuxLabel: "Deshaies",
    secteurs: ["basse-terre"],
    avantage: "Tarif réduit",
    photo: "/partenaires/kaz-a-jade-2.jpg",
    partenaires: ["Repaire Jade & Jack"],
    offres: [
      {
        type: "Journée bien-être avec spa",
        partenaire: "Repaire Jade & Jack",
        tel: "+590 690 80 97 74",
        lieu: "Deshaies",
        offre:
          "Une journée de 10 h à 22 h pour 1 ou 2 personnes : accès au lieu et au spa privatif, collation, massage et temps d'échange. Vue mer et nature. En option : jeu d'écho, oracle, massage plantaire.",
        duree: "1 journée (10 h à 22 h)",
        tarif_public: "188 €/pers.",
        tarif_tpoz: "150 €/pers.",
        avantage: "Tarif réduit",
        photoP: "/partenaires/kaz-a-jade-2.jpg",
        dispo: "Du 1er au 31 octobre",
        resa: "Réservation directe auprès du partenaire, en donnant votre code T'POZ",
        delai_reservation: "Selon disponibilités du partenaire",
      },
    ],
  },
  {
    id: "deux-nuits-jacuzzi",
    nom: "Deux nuits avec jacuzzi privatif",
    rubriques: ["souffler"],
    enCeMoment: true,
    momentNote: "Du 1er au 31 octobre",
    accroche: "Deux nuits dans un gîte paisible, avec un jacuzzi rien que pour soi.",
    comprend:
      "Un séjour de deux nuits pour 1 à 2 personnes, dans un gîte apaisant à deux pas des plages de Deshaies, avec jacuzzi privatif. Arrivée sans contact, linge fourni.",
    dureeLabel: "2 nuits",
    dureeCat: "nuit",
    lieuxLabel: "Deshaies",
    secteurs: ["basse-terre"],
    avantage: "Une nuit achetée = une nuit offerte",
    photo: "/partenaires/kaz-a-jade-jacuzzi.jpg",
    partenaires: ["Repaire Jade & Jack"],
    offres: [
      {
        type: "Séjour 2 nuits avec jacuzzi privatif",
        partenaire: "Repaire Jade & Jack",
        tel: "+590 690 80 97 74",
        lieu: "Deshaies",
        offre:
          "Deux nuits pour 1 à 2 personnes dans un gîte paisible à deux pas des plages, avec jacuzzi privatif. Arrivée sans contact, linge fourni, petit-déjeuner et massage en option.",
        duree: "2 nuits",
        tarif_public: "123 €/nuit",
        avantage: "50 % de remise : une nuit achetée = une nuit offerte",
        photoP: "/partenaires/kaz-a-jade-jacuzzi.jpg",
        dispo: "Du 1er au 31 octobre, en semaine",
        resa: "Réservation directe auprès du partenaire, en donnant votre code T'POZ",
        delai_reservation: "Au moins 2 jours avant",
      },
    ],
  },
  {
    id: "deux-nuits-nature",
    nom: "Deux nuits en pleine nature",
    rubriques: ["souffler"],
    accroche: "Deux nuits au calme, au cœur de la nature de Pointe-Noire.",
    comprend:
      "Un séjour de deux nuits minimum en pleine nature, dans un hôtel 4 étoiles au cadre calme et propice au ressourcement.",
    dureeLabel: "2 nuits minimum",
    dureeCat: "nuit",
    lieuxLabel: "Pointe-Noire",
    secteurs: ["basse-terre"],
    avantage: "Remise de 15 %",
    photo: "/partenaires/rocher-noir-jacuzzi.jpg",
    partenaires: ["Domaine du Rocher Noir"],
    offres: [
      {
        type: "Séjour 2 nuits en pleine nature",
        partenaire: "Domaine du Rocher Noir",
        tel: "+590 690 05 00 38",
        lieu: "Pointe-Noire",
        offre:
          "Un séjour de deux nuits minimum pour une à cinq personnes, dans un hôtel 4 étoiles en pleine nature. Piscine, jacuzzi privatif, parking, linge fourni, accessibilité PMR.",
        duree: "2 nuits minimum",
        tarif_public: "215 €/nuit",
        tarif_tpoz: "182,75 €/nuit",
        avantage: "−15 %",
        photoP: "/partenaires/rocher-noir-jacuzzi.jpg",
        dispo: "En semaine uniquement — hors jours fériés, vacances de Noël et Saint-Valentin. Arrivée entre 16 h et 19 h, départ avant 11 h 30",
        resa: "Réservation directe auprès du partenaire, en donnant votre code T'POZ",
        delai_reservation: "Au moins 2 jours avant",
      },
    ],
  },
  {
    id: "deux-nuits-vue-mer",
    nom: "Deux nuits avec vue sur la mer",
    rubriques: ["souffler"],
    accroche: "Deux nuits dans les hauteurs de Sofaïa, face à la mer.",
    comprend:
      "Un séjour de deux nuits minimum dans un hôtel de charme de 13 suites avec vue sur mer, dans un cadre calme et propice au ressourcement.",
    dureeLabel: "2 nuits minimum",
    dureeCat: "nuit",
    lieuxLabel: "Sainte-Rose (Sofaïa)",
    secteurs: ["basse-terre"],
    avantage: "Remise de 20 %",
    photo: "/partenaires/gaetana-1.jpeg",
    partenaires: ["Le Gaetana"],
    offres: [
      {
        type: "Séjour 2 nuits avec vue sur mer",
        partenaire: "Le Gaetana",
        tel: "+590 690 32 25 00",
        lieu: "Sainte-Rose (Sofaïa)",
        offre:
          "Un séjour de deux nuits minimum, pour 1 à 6 personnes, dans un hôtel de charme avec vue sur mer. Piscine, parking, linge fourni, petit-déjeuner en supplément.",
        duree: "2 nuits minimum",
        tarif_public: "180 €/nuit",
        tarif_tpoz: "144 €/nuit",
        avantage: "−20 %",
        photoP: "/partenaires/gaetana-1.jpeg",
        dispo: "Toute l'année, du lundi au dimanche",
        resa: "Réservation directe auprès du partenaire, en donnant votre code T'POZ",
        delai_reservation: "Au moins 1 jour avant",
      },
    ],
  },
  {
    id: "villa-piscine-proche",
    nom: "Une villa avec piscine, avec des proches",
    rubriques: ["souffler"],
    accroche: "Une villa avec piscine privée, à partager avec des proches.",
    comprend:
      "Un séjour de deux nuits dans une villa haut de gamme et indépendante, avec piscine privée, terrasse et jardin, à partager avec des proches.",
    dureeLabel: "2 nuits",
    dureeCat: "nuit",
    lieuxLabel: "Saint-François",
    secteurs: ["grande-terre"],
    avantage: "Remise de 20 %",
    photo: "/partenaires/abaneo-piscine.jpeg",
    partenaires: ["Villas Abaneo"],
    offres: [
      {
        type: "Séjour 2 nuits en villa avec piscine privée",
        partenaire: "Villas Abaneo",
        tel: "+590 690 98 03 24",
        lieu: "Saint-François",
        offre:
          "Un séjour de deux nuits pour 2 à 4 personnes dans une villa haut de gamme : piscine privée, terrasse, jardin, cuisine équipée, 2 chambres et 2 salles de bains. Wi-Fi, climatisation, linge fourni.",
        duree: "2 nuits",
        tarif_public: "201 €/nuit",
        tarif_tpoz: "160 €/nuit",
        avantage: "−20 %",
        photoP: "/partenaires/abaneo-piscine.jpeg",
        dispo: "Toute l'année",
        resa: "Réservation directe auprès du partenaire, en donnant votre code T'POZ. Acompte à la confirmation, solde à l'arrivée, caution de 1 000 €",
        delai_reservation: "Selon disponibilités du partenaire",
      },
    ],
  },
  {
    id: "escale-bord-de-mer",
    nom: "Une escale au bord de la mer",
    rubriques: ["souffler"],
    enCeMoment: true,
    momentNote: "Du 1er au 31 octobre",
    accroche: "Une parenthèse en bord de mer, entre piscine et plage.",
    comprend:
      "Un séjour en chambre double supérieure dans un hôtel 4 étoiles en bord de mer, avec petit-déjeuner américain.",
    dureeLabel: "1 nuit ou plus",
    dureeCat: "nuit",
    lieuxLabel: "Le Gosier",
    secteurs: ["grande-terre"],
    avantage: "Tarif réduit + petit-déjeuner offert",
    photo: "/partenaires/creole-beach-chambre3.jpg",
    partenaires: ["La Créole Beach Hotel & Spa"],
    offres: [
      {
        type: "Séjour en chambre double supérieure",
        partenaire: "La Créole Beach Hotel & Spa",
        tel: "+590 690 74 59 10",
        lieu: "Le Gosier",
        offre:
          "Un séjour en chambre double supérieure pour 2 personnes, avec petit-déjeuner américain. Bord de mer, piscine, restaurant, parking, Wi-Fi.",
        duree: "1 nuit ou plus",
        tarif_public: "270 €/nuit",
        tarif_tpoz: "220 €/nuit",
        avantage: "Tarif réduit + petit-déjeuner offert",
        photoP: "/partenaires/creole-beach-chambre3.jpg",
        dispo: "Du 1er au 31 octobre",
        resa: "Pré-réservation directe, puis confirmation de réservation par l'association",
        delai_reservation: "Selon disponibilités du partenaire",
      },
    ],
  },

  // ——— Prendre soin de moi en douceur ———
  {
    id: "pause-sophrologie",
    nom: "Une pause sophrologie",
    rubriques: ["prendre-soin"],
    accroche: "Un temps pour respirer, se détendre et se recentrer.",
    comprend:
      "Une séance de sophrologie adaptée à vos besoins : respiration, détente musculaire et visualisation positive, en individuel ou en collectif selon la praticienne choisie.",
    dureeLabel: "1 séance",
    dureeCat: "heures",
    lieuxLabel: "Le Gosier · Petit-Bourg · Sainte-Rose",
    secteurs: ["grande-terre", "basse-terre"],
    avantage: "Tarif réduit",
    photo: "/partenaires/pause-sophrologie.jpg",
    partenaires: ["Muriel Pradal", "Actions-Coaching"],
    offres: [
      {
        type: "Sophrologie individuelle",
        partenaire: "Muriel Pradal",
        tel: "+590 695 62 540",
        secteurs: ["grande-terre", "basse-terre"],
        lieu: "Le Gosier et Petit-Bourg",
        offre:
          "Une séance de sophrologie adaptée aux besoins de la bénéficiaire : respiration, détente musculaire et visualisation positive, pour un meilleur équilibre physique et mental.",
        duree: "1 séance",
        tarif_public: "65 €/pers.",
        tarif_tpoz: "35 €/pers.",
        avantage: "Tarif réduit",
        dispo: "Toute l'année, en semaine (lundi matin, mardi et jeudi toute la journée, vendredi après-midi)",
        resa: "Réservation directe auprès du partenaire, en donnant votre code T'POZ",
        delai_reservation: "Au moins 2 jours avant",
      },
      {
        type: "Sophrologie individuelle ou collective",
        partenaire: "Actions-Coaching",
        tel: "+590 690 75 59 50",
        secteurs: ["basse-terre"],
        lieu: "Sainte-Rose",
        offre:
          "Une séance de sophrologie individuelle, ou une séance collective en bord de mer / sophro-rando, pour favoriser la détente, la reconnexion à soi et la gestion du stress.",
        duree: "1 séance",
        formules: [
          { label: "Individuel", public: "15 €", tpoz: "7 €" },
          { label: "Collectif", public: "60 €", tpoz: "30 €" },
        ],
        avantage: "Tarif réduit",
        photoP: "/partenaires/actions-coaching-salle.jpg",
        dispo: "Toute l'année en semaine, hors vacances scolaires (lundi, mardi, mercredi et vendredi)",
        resa: "Réservation directe auprès du partenaire, en donnant votre code T'POZ",
        delai_reservation: "Selon disponibilités du partenaire",
      },
    ],
  },
  {
    id: "soin-intuitif-the",
    nom: "Un soin intuitif, suivi d'un thé",
    rubriques: ["prendre-soin"],
    accroche: "Un massage intuitif personnalisé, suivi d'un thé offert.",
    comprend:
      "Un massage intuitif personnalisé d'une heure à une heure trente, associé ou non à un soin énergétique, suivi d'un thé offert pour prolonger la détente.",
    dureeLabel: "1 h à 1 h 30",
    dureeCat: "heures",
    lieuxLabel: "Sainte-Rose",
    secteurs: ["basse-terre"],
    avantage: "Tarif réduit",
    photo: "/partenaires/o-petit-soin-carbet.jpg",
    partenaires: ["O'Petit Soin"],
    offres: [
      {
        type: "Massage intuitif et soin énergétique",
        partenaire: "O'Petit Soin",
        tel: "+590 690 60 81 14",
        lieu: "Sainte-Rose",
        offre:
          "1 h ou 1 h 30 de massage intuitif personnalisé, associé ou non à un soin énergétique de votre choix. Thé offert après le soin, linge fourni.",
        duree: "1 h à 1 h 30",
        tarif_public: "80 €/pers.",
        tarif_tpoz: "50 €/pers.",
        avantage: "Tarif réduit",
        photoP: "/partenaires/o-petit-soin-carbet.jpg",
        dispo: "Octobre, décembre, février, juillet — selon disponibilités",
        resa: "Réservation directe auprès du partenaire, en donnant votre code T'POZ",
        delai_reservation: "Selon disponibilités du partenaire",
      },
    ],
  },
  {
    id: "soin-equilibre",
    nom: "Un soin pour retrouver son équilibre",
    rubriques: ["prendre-soin"],
    accroche: "Un soin découverte pour prendre soin de soi et retrouver son équilibre.",
    comprend:
      "Un soin bien-être découverte avec Agathe, naturopathe et esthéticienne, pour prendre soin de soi et retrouver son équilibre.",
    dureeLabel: "1 séance",
    dureeCat: "heures",
    lieuxLabel: "Les Abymes",
    secteurs: ["grande-terre"],
    avantage: "Remise de 20 %",
    photo: "/partenaires/jolly-en-soi.jpg",
    partenaires: ["Jolly en Soi"],
    offres: [
      {
        type: "Soin bien-être découverte",
        partenaire: "Jolly en Soi",
        tel: "0690 33 32 38",
        lieu: "Les Abymes",
        offre:
          "Une offre découverte en soin bien-être, proposée par Agathe, naturopathe et esthéticienne, pour prendre soin de soi et retrouver son équilibre.",
        duree: "1 séance",
        tarif_public: "65 €/pers.",
        tarif_tpoz: "52 €/pers.",
        avantage: "−20 %",
        photoP: "/partenaires/jolly-en-soi.jpg",
        dispo: "Toute l'année, aux horaires habituels d'ouverture",
        resa: "Réservation selon les disponibilités de la partenaire, en donnant votre code T'POZ",
        delai_reservation: "Selon disponibilités du partenaire",
      },
    ],
  },

  // ——— Faire une activité qui me plaît ———
  {
    id: "cuisiner-et-ecrire",
    nom: "Cuisiner et écrire, le temps d'un atelier",
    rubriques: ["activite", "partager"],
    partagerNote: "Sessions ouvertes, pour partager le moment avec d'autres femmes",
    accroche: "Cuisiner, puis poser des mots sur les maux, le temps d'un atelier.",
    comprend:
      "Un atelier qui associe cuisine et écriture intuitive : un cours de cuisine avec une ou deux recettes, puis un temps d'écriture pour mettre des mots sur les maux. En session ouverte, l'atelier se partage avec d'autres femmes.",
    dureeLabel: "Une demi-journée",
    dureeCat: "demi-journee",
    lieuxLabel: "Saint-François",
    secteurs: ["grande-terre"],
    avantage: "Tarif réduit",
    photo: "/partenaires/sab-et-sens-3.jpg",
    partenaires: ["Sab et Sens"],
    offres: [
      {
        type: "Atelier cuisine & écriture intuitive",
        partenaire: "Sab et Sens",
        tel: "+590 690 16 28 08",
        lieu: "Saint-François",
        offre:
          "Un cours de cuisine avec une ou deux recettes, suivi d'un temps d'écriture intuitive pour mettre des mots sur les maux. De 2 à 8 personnes — sessions ouvertes pour partager le moment avec d'autres femmes.",
        duree: "Une demi-journée",
        tarif_public: "60 €/pers.",
        tarif_tpoz: "45 €/pers.",
        avantage: "Tarif réduit",
        photoP: "/partenaires/sab-et-sens-atelier.jpg",
        dispo: "Toute l'année — mercredi ou samedi",
        resa: "Réservation directe auprès du partenaire, en donnant votre code T'POZ",
        delai_reservation: "Selon disponibilités du partenaire",
      },
    ],
  },
  {
    id: "decouvrir-neurofeedback",
    nom: "Découvrir le neurofeedback",
    rubriques: ["activite"],
    accroche: "Découvrir une approche douce qui aide le cerveau à s'apaiser.",
    comprend:
      "Une séance découverte de neurofeedback, une approche qui entraîne le cerveau à s'autoréguler et favorise le bien-être.",
    dureeLabel: "1 séance",
    dureeCat: "heures",
    lieuxLabel: "Sainte-Anne · Les Abymes",
    secteurs: ["grande-terre"],
    avantage: "Séance découverte offerte ou tarif réduit",
    photo: "/partenaires/neurofeedback-tpoz.jpg",
    partenaires: ["Fée pour Soi", "Bulles 2 Bien-Être"],
    offres: [
      {
        type: "Séance découverte de neurofeedback",
        partenaire: "Fée pour Soi",
        tel: "+590 690 36 16 34",
        secteurs: ["grande-terre"],
        lieu: "Sainte-Anne",
        offre:
          "Une séance découverte de neurofeedback, proposée par Laïla, praticienne en bien-être et épanouissement personnel.",
        duree: "1 séance",
        tarif_public: "communiqué par la partenaire",
        tarif_tpoz: "Offerte",
        avantage: "Séance découverte offerte + −35 % sur le programme (12 séances min.)",
        photoP: "/partenaires/fee-pour-soi-salon.jpg",
        dispo: "Mercredi à Sainte-Anne, vendredi à Jarry",
        resa: "Réservation directe auprès du partenaire, en donnant votre code T'POZ",
        delai_reservation: "Au moins 5 jours avant",
      },
      {
        type: "Séance découverte de neurofeedback dynamique",
        partenaire: "Bulles 2 Bien-Être",
        tel: "+590 690 98 93 72",
        secteurs: ["grande-terre"],
        lieu: "Les Abymes",
        offre:
          "Une séance découverte d'1 h de neurofeedback NeurOptimal, en individuel, avec musique ou film pendant la séance. Information pratique : à l'étage (15 marches).",
        duree: "1 heure",
        tarif_public: "65 €/pers.",
        tarif_tpoz: "39 € + forfait T'POZ",
        avantage: "Tarif réduit sur la 1re séance",
        photoP: "/partenaires/bulles2-ambiance.jpg",
        dispo: "Toute l'année, du lundi au vendredi",
        resa: "Réservation directe auprès du partenaire, en donnant votre code T'POZ",
        delai_reservation: "Selon disponibilités du partenaire",
      },
    ],
  },
  {
    id: "coaching-therapie",
    nom: "Une séance de coaching-thérapie",
    rubriques: ["prendre-soin"],
    accroche: "Un temps d'écoute et d'accompagnement pour déposer ce qui pèse et avancer.",
    comprend:
      "Une séance individuelle de coaching-thérapie, pour mettre des mots sur ce que vous traversez, reprendre confiance et avancer à votre rythme, accompagnée par une professionnelle.",
    dureeLabel: "1 séance",
    dureeCat: "heures",
    lieuxLabel: "Les Abymes",
    secteurs: ["grande-terre"],
    avantage: "Tarif réduit",
    photo: "/partenaires/bulles2-ambiance.jpg",
    partenaires: ["Bulles 2 Bien-Être"],
    offres: [
      {
        type: "Séance de coaching-thérapie",
        partenaire: "Bulles 2 Bien-Être",
        tel: "+590 690 98 93 72",
        secteurs: ["grande-terre"],
        lieu: "Les Abymes",
        offre:
          "Une séance individuelle de coaching-thérapie pour déposer ce qui pèse, y voir plus clair et reprendre confiance. Information pratique : à l'étage (15 marches).",
        duree: "1 séance",
        tarif_public: "100 €/pers.",
        tarif_tpoz: "80 €/pers.",
        avantage: "Tarif réduit",
        photoP: "/partenaires/bulles2-ambiance.jpg",
        dispo: "Toute l'année, du lundi au vendredi",
        resa: "Réservation directe auprès du partenaire, en donnant votre code T'POZ",
        delai_reservation: "Selon disponibilités du partenaire",
      },
    ],
  },

  // ——— Partager un moment avec d'autres femmes ———
  {
    id: "respirer-ensemble",
    nom: "Respirer ensemble au bord de mer",
    rubriques: ["partager"],
    accroche: "Une séance collective de sophrologie, les pieds dans le sable.",
    comprend:
      "Une séance collective de sophrologie en bord de mer ou une sophro-rando, animée par Sonia, pour respirer ensemble et alléger la charge mentale.",
    dureeLabel: "1 séance",
    dureeCat: "heures",
    lieuxLabel: "Sainte-Rose",
    secteurs: ["basse-terre"],
    avantage: "Tarif réduit",
    photo: "/partenaires/respirer-bord-de-mer.jpg",
    partenaires: ["Actions-Coaching"],
    offres: [
      {
        type: "Sophrologie collective en bord de mer / sophro-rando",
        partenaire: "Actions-Coaching",
        tel: "+590 690 75 59 50",
        secteurs: ["basse-terre"],
        lieu: "Sainte-Rose",
        offre:
          "Une séance collective en bord de mer ou une sophro-rando, en petit groupe (jusqu'à 6 personnes). Baignade recommandée pour les séances en bord de mer.",
        duree: "1 séance",
        tarif_public: "60 €/pers.",
        tarif_tpoz: "30 €/pers.",
        avantage: "Tarif réduit",
        photoP: "/partenaires/actions-coaching-salle.jpg",
        dispo: "Toute l'année en semaine, hors vacances scolaires (lundi, mardi, mercredi et vendredi)",
        resa: "Réservation directe auprès du partenaire, en donnant votre code T'POZ",
        delai_reservation: "Selon disponibilités du partenaire",
      },
    ],
  },
  // ——— Conçues par T'POZ ———
  {
    id: "24h-sainte-rose",
    nom: "24 h pour souffler à Sainte-Rose",
    rubriques: ["concues"],
    statut: "À présenter",
    enCeMoment: false,
    momentNote: "Bientôt dévoilée",
    accroche: "Une parenthèse de 24 heures, conçue de bout en bout par T'POZ.",
    comprend:
      "Un programme de 24 heures imaginé par l'association pour souffler, se reposer et prendre soin de soi, à Sainte-Rose. Le détail sera bientôt dévoilé.",
    dureeLabel: "24 heures",
    dureeCat: "nuit",
    lieuxLabel: "Sainte-Rose",
    secteurs: ["basse-terre"],
    avantage: "Conçue par T'POZ",
    photo: "/partenaires/o-petit-soin-plage.jpg",
    partenaires: ["T'POZ"],
    offres: [],
  },
  {
    id: "escapade-saint-francois",
    nom: "Escapade à Saint-François",
    rubriques: ["concues"],
    statut: "À présenter",
    accroche: "Une escapade d'une journée, imaginée par l'association.",
    comprend:
      "Une journée d'escapade à Saint-François, imaginée par l'association. Le programme sera bientôt dévoilé.",
    dureeLabel: "1 journée",
    dureeCat: "journee",
    lieuxLabel: "Saint-François",
    secteurs: ["grande-terre"],
    avantage: "Conçue par T'POZ",
    photo: "/partenaires/sab-et-sens-atelier.jpg",
    partenaires: ["T'POZ"],
    offres: [],
  },
  {
    id: "sejour-groupe-abaneo",
    nom: "Un séjour de groupe aux Villas Abaneo avec l'atelier de Sab et Sens",
    rubriques: ["concues"],
    statut: "À venir",
    accroche: "Un séjour partagé entre femmes, entre villa avec piscine et atelier cuisine & écriture.",
    comprend:
      "Un séjour de groupe aux Villas Abaneo, associé à l'atelier cuisine et écriture de Sab et Sens. Le programme sera bientôt dévoilé.",
    dureeLabel: "Séjour de groupe",
    dureeCat: "nuit",
    lieuxLabel: "Saint-François",
    secteurs: ["grande-terre"],
    avantage: "Conçue par T'POZ",
    photo: "/partenaires/abaneo-jacuzzi.jpeg",
    partenaires: ["T'POZ", "Villas Abaneo", "Sab et Sens"],
    offres: [],
  },
];

export const getExperience = (id) => EXPERIENCES.find((e) => e.id === id);

// Thèmes du bloc « En ce moment » de la page d'accueil.
// Un seul thème actif à la fois ; le bloc se masque automatiquement après la date de fin.
export const THEMES_MOMENT = [
  {
    id: "octobre-rose",
    actif: false, // à réactiver en octobre 2027 (mettre à jour debut/fin)
    surtitre: "Octobre Rose",
    titreEm: "Octobre Rose",
    texte:
      "Tout au long d'octobre, mois de mobilisation contre le cancer du sein, ces T'POZ sont mises en avant pour offrir douceur et répit aux femmes concernées — et à toutes celles qui en ont besoin.",
    badge: "Octobre Rose",
    badgeIcon: "ribbon",
    couleur: "#D23F6F",
    periodeCartes: "Du 1er au 31 octobre",
    debut: "2026-10-01",
    fin: "2026-10-31",
    experiences: ["deux-nuits-jacuzzi", "escale-bord-de-mer"],
  },
  {
    id: "offrir-tpoz",
    actif: true,
    surtitre: "Offrir une T'POZ",
    titreEm: "Offrir une T'POZ",
    texte:
      "Jusqu'aux fêtes, ces T'POZ sont mises en avant pour être offertes : à une proche, ou en T'POZ suspendue à une femme qui en a besoin.",
    badge: "À offrir",
    badgeIcon: "gift",
    couleur: "#B08D57",
    periodeCartes: "Du 1er novembre au 31 décembre",
    debut: "2026-11-01",
    fin: "2026-12-31",
    experiences: ["une-heure-de-massage", "decouvrir-neurofeedback", "deux-nuits-nature"],
  },
];

export const getThemeMoment = (now = new Date()) =>
  THEMES_MOMENT.find(
    (t) => t.actif && now >= new Date(`${t.debut}T00:00:00`) && now <= new Date(`${t.fin}T23:59:59`)
  ) || null;
